import BaseService from './BaseService'
import type { PlantApplicationDto } from './PlantService.types'

export default class PlantService extends BaseService {
  async application(data: PlantApplicationDto, captcha: string): Promise<void> {
    await this.client.post(`/plant/application?captcha=${captcha}`, data)
  }
}
